<template>
  <form class="container-fluid body">
    <div class="container arnergy_lux">
      <div class="cotainer">
        <h2 style="color:#0892D0;">
          Update Arnergy Lux Device - {{ this.$route.params.exportDeviceid }}
        </h2>
      </div>
      <div class="container">
        <!-- <DeviceSerial /> -->
        <div class="container device_serial">
          <!-- Pick one or more Serial Number -->
          <div class="row mul_select">
            <div class="col-12 multiple_option">
              <label style="color:#0892D0;" for="lux_serial_number"
                >Pick one or more Lux Serial Number</label
              >
              <select
                name="lux_serial_number"
                id="lux_serial_number"
                v-model="regparams.serialNumbers"
                multiple
                size="2"
                class="form-control"
              >
                <option value="2480530042">2480530042</option>
                <option value="2480530073">2480530073</option>
                <option value="ARN-416773">ARN-416773</option>
                <option value="ARN-416774">ARN-416774</option>
                <option value="ARN-416775">ARN-416775</option>
                <option value="ARN-416776">ARN-416776</option>
                <option value="ARN-416777">ARN-416777</option>
                <option value="ARN-416778">ARN-416778</option>
                <option value="ARN-416779">ARN-416779</option>
                <option value="ARN-416770">ARN-416770</option>
                <option value="ARN-4167712">ARN-4167712</option>
              </select>
            </div>
          </div>
        </div>
        <!-- <LuxPayment /> -->
        <div class="container lux_payment">
          <!-- Select Payment Type -->
          <div class="row lux_payment_row">
            <div class="col-12">
              <label style="color:#0892D0;" for="payment_type"
                >Select Payment Type</label
              >
              <select
                name="payment_type"
                id="payment_type"
                v-model="regparams.paymentType"
                placeholder="Select a payment type"
                class="form-control form-control-lg"
                required
              >
                <option value="" disabled selected hidden
                  >Select Payment Type</option
                >
                <option value="OS">Outright Sale (OS)</option>
                <option value="LO">Lease to Own (LO)</option>
                <option value="ES">ENERGY AS A SERVICE (ES)</option>
              </select>
            </div>
          </div>
          <!-- Enter CLoad Value -->
          <div class="row">
            <div class="col-12">
              <label style="color:#0892D0;" for="CLoad"
                >Enter CLoad Value</label
              >
              <input
                type="number"
                name="Cload"
                id="Cload"
                v-model="regparams.CLoad"
                placeholder="Input Cload"
                class="form-control form-control-lg"
              />
            </div>
          </div>
          <!-- Select Device Version -->
          <div class="row">
            <div class="col-12">
              <label style="color:#0892D0;" for="device_version"
                >Select Device Version</label
              >
              <select
                name="device_version"
                id="device_version"
                v-model="regparams.Version"
                placeholder="Version _"
                class="form-control form-control-lg"
                required
              >
                <option value="" disabled selected hidden
                  >Select Device Version</option
                >
                <option value="v3">System Version 3</option>
                <option value="v5">System Version 5</option>
                <option value="v6">System Version 6</option>
                <option value="v7">System Version 7</option>
              </select>
            </div>
          </div>
        </div>
        <!-- <LuxMisc /> -->
        <div class="container luxMisc">
          <div class="row">
            <!-- CID -->
            <div class="col-md-4">
              <label style="color:#0892D0;" for="CID">Device CID</label>
              <input
                type="number"
                name="CID"
                id="CID"
                v-model="regparams.MiscData.CID"
                placeholder="CID number"
                class="form-control form-control-lg"
              />
            </div>
            <!-- Charge Cycle -->
            <div class="col-md-4">
              <label style="color:#0892D0;" for="charge_cycle"
                >Charge Cycle</label
              >
              <input
                type="number"
                name="Charge Cycle"
                id="charge_cycle"
                v-model="regparams.MiscData.ChgCycle"
                placeholder="Charge Cycle"
                class="form-control form-control-lg"
              />
            </div>
            <!-- Exptd. Charge Cycle -->
            <div class="col-md-4">
              <label style="color:#0892D0;" for="E_charge_cycle"
                >Exptd. Charge Cycle</label
              >
              <input
                type="number"
                name="E_charge_cycle"
                id="E_charge_cycle"
                v-model="regparams.MiscData.ExptdChgCyl"
                placeholder="Expected Charge"
                class="form-control form-control-lg"
              />
            </div>
          </div>
          <div class="row">
            <!-- LAC -->
            <div class="col-md-4">
              <label style="color:#0892D0;" for="LAC">LAC</label>
              <input
                type="number"
                name="LAC"
                id="LAC"
                v-model="regparams.MiscData.LAC"
                placeholder="LAC"
                class="form-control form-control-lg"
              />
            </div>
            <!-- MCC -->
            <div class="col-md-4">
              <label style="color:#0892D0;" for="MCC">MCC</label>
              <input
                type="number"
                name="MCC"
                id="MCC"
                v-model="regparams.MiscData.MCC"
                placeholder="MCC"
                class="form-control form-control-lg"
              />
            </div>
            <!-- MNC -->
            <div class="col-md-4">
              <label style="color:#0892D0;" for="MNC">MNC</label>
              <input
                type="number"
                name="MNC"
                id="MNC"
                v-model="regparams.MiscData.MNC"
                placeholder="MNC"
                class="form-control form-control-lg"
              />
            </div>
          </div>
          <div class="row">
            <!-- PAP -->
            <div class="col-md-4">
              <label style="color:#0892D0;" for="PAP">PAP</label>
              <input
                type="number"
                name="PAP"
                id="PAP"
                v-model="regparams.MiscData.PAP"
                placeholder="PAP"
                class="form-control form-control-lg"
              />
            </div>
            <!-- PAT -->
            <div class="col-md-4">
              <label style="color:#0892D0;" for="PAT">PAT</label>
              <input
                type="number"
                name="PAT"
                id="PAT"
                v-model="regparams.MiscData.PAT"
                placeholder="PAT"
                class="form-control form-control-lg"
              />
            </div>
            <!-- PSC -->
            <div class="col-md-4">
              <label style="color:#0892D0;" for="PSC">PSC</label>
              <input
                type="number"
                name="PSC"
                id="PSC"
                v-model="regparams.MiscData.PSC"
                placeholder="PSC"
                class="form-control form-control-lg"
              />
            </div>
          </div>
          <div class="row">
            <!-- Radio -->
            <div class="col-md-4">
              <label style="color:#0892D0;" for="Radio">Radio</label>
              <input
                type="text"
                name="Radio"
                id="Radio"
                v-model="regparams.MiscData.Radio"
                placeholder="Radio"
                class="form-control form-control-lg"
              />
            </div>
            <!-- SIM -->
            <div class="col-md-4">
              <label style="color:#0892D0;" for="SIM">SIM</label>
              <input
                type="text"
                name="SIM"
                id="SIM"
                v-model="regparams.MiscData.SIM"
                placeholder="SIM"
                class="form-control form-control-lg"
              />
            </div>
          </div>
        </div>
        <!-- Button -->
        <div class="container button_style">
          <div class="row">
            <div class="col-md-10"></div>
            <div class="col-md-2">
              <button
                type="button"
                class="btn btn-primary btn-lg"
                @click="submit"
              >
                Enter
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import { isEmpty } from "element-ui/src/utils/util";
export default {
  name: "LuxDeviceUpdate",
  data() {
    return {
      regparams: {
        serialNumbers: [],
        paymentType: "",
        CLoad: "",
        Version: "",
        MiscData: {
          CID: "",
          ChgCycle: "",
          ExptdChgCyl: "",
          LAC: "",
          MCC: "",
          MNC: "",
          PAP: "",
          PAT: "",
          PSC: "",
          Radio: "",
          SIM: ""
        }
      },
      errorsResult: {}
    };
  },
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
      message: "Success Msg!"
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
      message: "Error Msg!"
    }
  },
  methods: {
    validateReg() {
      let errors = [];
      for (let [field, value] of Object.entries(this.regparams)) {
        value = value + "";
        if (value !== null && value !== Number.isInteger(value)) {
          value = value.trim();
        }
        switch (field) {
          case "serialNumbers":
            if (value === [] || value === NaN || isEmpty(value)) {
              errors[field] = "Serial Number cannot be empty.";
            }
            break;
          case "paymentType":
            if (value === "" || value === NaN || isEmpty(value)) {
              errors[field] = "Payment type cannot be empty.";
            }
            break;
          case "CLoad":
            if (value === "" || value === NaN || isEmpty(value)) {
              errors[field] = "Contractual Load cannot be empty.";
            }
            break;
          case "Version":
            if (value === null || value === NaN || isEmpty(value)) {
              errors[field] = "Device version cannot be empty.";
            }
            break;
          default:
            break;
        }
      }
      for (let [field, value] of Object.entries(this.regparams.MiscData)) {
        value = value + "";
        if (value !== null && value !== Number.isInteger(value)) {
          value = value.trim();
        }
        switch (field) {
          case "CID":
            if (value === "" || value === NaN || isEmpty(value)) {
              errors[field] = "CID cannot be empty.";
            }
            break;
          case "ChgCycle":
            if (value === [] || value === NaN || isEmpty(value)) {
              errors[field] = "Charge Cycle cannot be empty.";
            }
            break;
          case "ExptdChgCyl":
            if (value === "" || value === NaN || isEmpty(value)) {
              errors[field] = "Expected Charge cycle cannot be empty.";
            }
            break;
          case "LAC":
            if (value === "" || value === NaN || isEmpty(value)) {
              errors[field] = "LAC cannot be empty.";
            }
            break;
          case "MCC":
            if (value === null || value === NaN || isEmpty(value)) {
              errors[field] = "MCC cannot be empty.";
            }
            break;
          case "PAP":
            if (value === null || value === NaN || isEmpty(value)) {
              errors[field] = "PAP cannot be empty.";
            }
            break;
          case "PAT":
            if (value === null || value === NaN || isEmpty(value)) {
              errors[field] = "PAT cannot be empty.";
            }
            break;
          case "PSC":
            if (value === null || value === NaN || isEmpty(value)) {
              errors[field] = "PSC cannot be empty.";
            }
            break;
          case "Radio":
            if (value === null || value === NaN || isEmpty(value)) {
              errors[field] = "RADIO cannot be empty.";
            }
            break;
          case "SIM":
            if (value === null || value === NaN || isEmpty(value)) {
              errors[field] = "SIM cannot be empty.";
            }
            break;
          default:
            break;
        }
        this.errorsResult = errors;
      }
    },

    submit() {
      this.validateReg();
      var errorLength = Object.keys(this.errorsResult).length;
      if (errorLength > 0) {
        this.errorMessage = "Fill All FIelds!!!";
        this.displayError = true;
        setTimeout(() => {
          this.displayError = false;
        }, 3000);
        var errorMsg = Object.values(this.errorsResult).join("<br>");
        this.showErrorMsg({
          message: errorMsg
        });

        return;
      }
      const LuxHTTP = this.$httpUtils.LUXHTTP;
      const url = `/devices/${this.$route.params.exportDeviceid}`;
      LuxHTTP.patch(url, this.regparams)
        .then(res => {
          console.log("response", res);
          this.showSuccessMsg({
            message: "Your LUX onboarding update was successful"
          });
          window.history.back();
        })
        .catch(error => {
          console.log("setup error", error.response);
          this.showErrorMsg({ message: error.response.data.detail.message });
        });
    }
  },
  mounted() {}
};
</script>

<style scoped>
.body {
  background-color: #ffffff;
  height: 50%;
  padding: 6% 0 12%;
}
.arnergy_lux h2 {
  width: 85%;
  margin: auto 6px auto auto;
}
.device_serial {
  font-family: sans-serif;
  width: 90%;
  max-width: 654px;
  padding-top: 18px;
}
.device_serial select {
  background: #f1f1f1;
  border: none;
  box-shadow: none;
  outline: none;
  height: 55px !important;
  border-radius: 3px;
  padding-left: 26px;
  color: #222;
}
.device_serial label {
  font-size: 12px;
  font-weight: 500;
  margin-top: 12px;
}
.multiple_option select {
  height: 120px !important;
}

.lux_payment {
  font-family: sans-serif;
  width: 90%;
  max-width: 654px;
  padding-top: 18px;
}
.lux_payment label {
  font-size: 12px;
  font-weight: 500;
  margin-top: 12px;
}
.lux_payment select {
  background: #f1f1f1;
  border: none;
  box-shadow: none;
  outline: none;
  height: 55px !important;
  border-radius: 3px;
  padding-left: 26px;
  color: #222;
}
.lux_payment input {
  background: #f1f1f1;
  border: none;
  box-shadow: none;
  outline: none;
  height: 55px !important;
  border-radius: 3px;
  padding-left: 26px;
  color: #222;
}
.luxMisc {
  font-family: sans-serif;
  width: 90%;
  max-width: 654px;
  padding-top: 18px;
}
.luxMisc label {
  font-size: 12px;
  font-weight: 500;
  margin-top: 12px;
}
.luxMisc input {
  background: #f1f1f1;
  border: none;
  box-shadow: none;
  outline: none;
  height: 55px !important;
  border-radius: 3px;
  padding-left: 26px;
  color: #222;
}
.button_style {
  font-family: sans-serif;
  width: 90%;
  max-width: 654px;
  padding-top: 18px;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/luxOnboarding/LuxDeviceUpdate.vue